<template>
  <div class="relative mt-20 mb-20 max-w-screen-sm left-1/2 -translate-x-1/2">
    <div class="flex flex-col flex-wrap align-center">
      <div class="px-12">
        <h2><span class="font-bold">{{ userStore.user.name }}</span>, consistency is the foundation of sleep</h2>
        <p>Getting to bed at the same time is the <span class="font-bold">best</span> way to improve your sleep.</p>
      </div>
      <h3 class="mt-6">When do you need to wake up by?</h3>
      <!-- <p>Your current target for sleep is {{ target?.duration }} hours per night.</p> -->
      <TimePicker :initialTime='time24To12(target?.wakeTime)' @get-time="handleGetTime"/>
      <p class="mx-12">Based on your sleep data, your bedtime should be no later than {{ time24To12(target?.bedTime) }}.</p>
      <button @click="goToNext()">
        <span>Next →</span>
      </button>
    </div>
  </div>
</template>

<script>
import TimePicker from '@/components/TimePicker'
import { get7DaysAgo, time24To12, time12To24, roundUp15Minutes, subtractDurationFromTime } from "@/helpers/time"
import { mapStores } from 'pinia'
import { useUserStore } from '@/stores/user'

export default {
  name: 'OnboardingTargets',
  components: {
    TimePicker
  },
  data() {
    return {
      dates: get7DaysAgo(),
      target: undefined,
      efficiency: undefined,
    }
  },
  beforeMount() {
    // TODO: Remove this temporary fix; skip onboarding if target exists.
    if (this.userStore.user.target) this.$router.push('/')

    this.loadTarget()
    this.loadEfficiency()
  },
  methods: {
    async loadTarget() {
      // Load the page with Fitbit target or default if none exists.
      this.target = await this.userStore.user.syncFitbitTarget()
      if (!this.target) {
        this.target = {
          duration: 7 * 60,
          bedTime: '22:15',
          wakeTime: '07:00',
        }
      }
    },
    async loadEfficiency() {
      // If efficiency is null then we need to set a default.
      this.efficiency = await this.userStore.user.getSleepEfficiency(
        this.dates.start,
        this.dates.end
      ) ?? 0.8
    },
    time24To12(t) {
      return time24To12(t)
    },
    time12To24(t) {
      return time12To24(t)
    },
    handleGetTime(t) {
      // When the time is updated, consume the emitted event to calculate the
      // bed time based on sleep duration target and past 7d efficiency.
      this.target.wakeTime = this.time12To24(t)
      this.target.bedTime = subtractDurationFromTime(
        this.target.wakeTime,
        this.target.duration / this.efficiency,
        true
      )
      this.target.bedTime = roundUp15Minutes(this.target.bedTime, true)
    },
    async goToNext() {
      // Save target.
      if (this.target.id) {
        await this.userStore.user.saveSleepTarget(this.target)
      } else {
        await this.userStore.user.createSleepTarget(this.target)
      }
      this.$router.push('/onboarding/analysis')
    },
  },
  computed: {
    ...mapStores(useUserStore),
  },
}
</script>